import { Observable } from 'rxjs';
import { ApiService, GET_USER_GAMES_PATH, GetUserGamesPathParams, GetUserGamesResponse } from '@core-http';

export class UserGamesHttpService extends ApiService {
  getLastGames(pathParams: GetUserGamesPathParams): Observable<GetUserGamesResponse> {
    const path: string = this.fillPathParams(GET_USER_GAMES_PATH, pathParams);

    return this.httpClient.get<GetUserGamesResponse>(`${this.env.apiUrl}${path}`);
  }
}
